import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Font, PDFViewer, Page, Text, View, Document, StyleSheet, Svg, Circle, Path, Image } from "@react-pdf/renderer";
// import { lightGreen } from "@mui/material/colors";
import StudentAmbitionCard from "./studentAmbitionCard";
import StudentSummary from "./studentSummary";
Font.register({
    family: 'Calibri',
    fonts: [
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf", format: 'truetype' },
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold", format: 'truetype' }
    ]
});

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});
// Sample JSON object
const donutPositions = [
    { cx: 100, cy: 100 },
    { cx: 300, cy: 250 },
    { cx: 400, cy: 300 },
    { cx: 500, cy: 400 },
    { cx: 150, cy: 500 },
    { cx: 250, cy: 600 },
    { cx: 350, cy: 700 },
    { cx: 450, cy: 200 },
    { cx: 550, cy: 100 },
];

// PDF Component
const StudentPDF = (props) => {
    const lstGoals = ["Children develop habits that keep them healthy and safe."
        , "Children develop sharpness in sensorial perceptions."
        , "Children develop a fit and flexible body."];
    const lstAssessmentQuestion = ["How does child demonstrate coordination and balance while participating in ball activities, such as dribbling or catching a ball? Are they able to maintain control of the ball and adjust their movements to keep it in motion?"
        , "During group ball activities, how does child interact with peers? Do they take turns, collaborate, and show enthusiasm for playing with others? How well do they follow the rules and share the ball during team games?"
        , "How does child express different emotions during Emotion Charades activities? Are they able to accurately show feelings such as happiness, sadness, or anger through body language and facial expressions?"];
    const lstPerformanceDescriptor = [
        {
            "domainId": 1,
            "domain": "Physical Development",
            "comment": "The student demonstrates strong gross and fine motor skills. They actively engage in physical activities, showing increasing coordination and control in tasks like running, jumping, and catching. "
        },
        {
            "domainId": 2,
            "domain": "Socio-emotional Development",
            "comment": "The student is developing positive social skills and demonstrates increasing empathy in group settings. They interact well with peers, take turns, and express emotions more clearly."
        },
        {
            "domainId": 3,
            "domain": "Cognitive Development",
            "comment": "The student exhibits curiosity and problem-solving skills. They can follow simple instructions and engage in basic tasks with attention to detail."
        },
        {
            "domainId": 4,
            "domain": "Language and Literacy Development",
            "comment": "The student demonstrates a growing vocabulary and enjoys expressing themselves verbally. They actively participate in storytelling and discussions, and their ability to recognize letters and sounds is developing."
        },
        {
            "domainId": 5,
            "domain": "Aesthetic and Cultural Development",
            "comment": "The student engages actively in creative activities, such as drawing, music, and imaginative play. They are developing an appreciation for different forms of art and culture."
        },
        {
            "domainId": 6,
            "domain": "Positive Learning Habits",
            "comment": "The student is showing increasing independence in their learning activities. They follow routines and complete tasks with minimal prompting."
        }
    ];
    const lstFriend = ["Alice", "Bob", "Charlie"];
    const observationalNotes = ["Demonstrates positive interactions with peers, showing a willingness to share and\
         collaborate during group activities. They often take the role of a helper, showing empathy\
          towards classmates who need assistance."
        , "Able to regulate emotions well, though they\
           occasionally need reminders when feeling frustrated during challenging tasks. They are beginning to\
            develop strategies to cope with these emotions, such as asking for a break when overwhelmed."
        , "Respond well to praise and often smile when receiving positive reinforcement, which boosts their confidence."
        , "Shows strong problem-solving skills. For example, when faced with a new puzzle, they will work through it methodically\
         and ask insightful questions when they encounter difficulties."
        , "Their memory retention is notable as they can recall information from previous lessons and apply it to new situations.\
         For instance, they were able to relate their learning about numbers to a new story problem\
         introduced in class."
        , "Demonstrates curiosity and often asks questions that extend beyond the curriculum, showing a deep interest in learning."
        , "Developing strong verbal communication skills. They articulate their thoughts clearly and participate actively\
        in class discussions. They enjoy expressing themselves and are able to narrate simple stories."
        , "Listens attentively to others in group settings and waits their turn to speak, showing respect for the communication process."
        , "enthusiastic and enjoys running, jumping, and playing games with their peers. They are working on improving their coordination and often take on leadership roles during group sports activities."];
    const myFavourite = {
        color: "Blue",
        flower: "Rose",
        food: "Pizza",
        sport: "Cricket",
        animal: "Dog",
        subject: "Math",
    }
    // Styles for the PDF
    const styles = StyleSheet.create({
        bgPartA2: {
            backgroundColor: '#fff'//'#fee4a4'
        },
        page: {
            position: "relative",
            fontSize: 12,
            padding: 20,
            backgroundColor: props.partAColor//"#5e35b1",
        },
        f2: {
            flex: 2,
        },
        bDarkOrange: {
            border: '8px solid darkorange',
        },
        fDirectionRow: {
            flexDirection: 'row'
        },
        alignStart: {
            alignItems: 'flex-start'
        },
        fDirectionCol: {
            flexDirection: 'column'
        },
        justifyCenter: {
            justifyContent: 'center'
        },
        blueBorder: {
            border: '2px solid #0091cd',
        },
        bRadius70: {
            borderRadius: 70,
        },
        box100px: {
            height: 100,
            width: 100
        },
        alignCenter: {
            alignItems: 'center'
        },
        textBrown: {
            color: 'brown'
        },
        textBlue: {
            color: '#0091cd'
        },
        bgWhite: {
            backgroundColor: '#fff',
        },
        brownBorder: {
            border: '2px solid brown',
        },
        leftPart: {
            flex: 1
            , flexDirection: "column"
        },
        rightPart: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        header1: {

            fontSize: 16,
            fontWeight: "bold",
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#e36c0a',
            fontFamily: 'Helvetica-Bold',
            // borderRadius: 6,
            padding: 10,
            paddingTop: 30
        }, header2: {
            fontSize: 12,
            fontWeight: "bold",
            textAlign: 'center',
            textTransform: 'capitalize',
            fontFamily: 'Helvetica-Bold',
            color: '#000',
            // borderRadius: 6,
            padding: 5
        },
        header: {
            fontSize: 14,
            fontWeight: "bold",
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#000',
            backgroundColor: 'darkorange',
            // borderRadius: 6,
            padding: 5
        },
        section: {
            border: '1px solid darkorange',
            margin: 10,
            // backgroundColor: 'rgba(180, 180, 180, 0.4)'
        },
        gradeRow: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 5,
        },
        text: {
            fontSize: 12,
            zIndex: 2, // Ensures text is above the background
        },
        row: {
            flexDirection: "row",
            marginBottom: 5,
            alignItems: "center",
        },
        splitRow: {
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
        },
        firsthalf: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        secondhalf: {
            flex: 1, // Equal width for both sections
            flexDirection: "row",
            alignItems: "center"
        },
        label1: {
            width: "40%", // Allocate space for the label
            color: "#000",
            fontSize: 11,
            textAlign: "left", // Align labels to the right
            marginLeft: 5
        },
        label: {
            width: "20%", // Allocate space for the label
            color: "#000",
            fontSize: 11,
            textAlign: "left", // Align labels to the right
            marginLeft: 5,
        },
        colon: {
            width: "5%", // Space for the colon
            color: "#000",
            fontSize: 11,
            textAlign: "center", // Center the colon
        },
        colon1: {
            width: "10%", // Space for the colon
            color: "#000",
            fontSize: 11,
            textAlign: "center", // Center the colon
        },
        value: {
            width: "70%", // Allocate space for the value
            color: "#FFFFFF",
            fontSize: 11,
            textAlign: "left", // Align values to the left
        },
        value1: {
            width: "40%", // Allocate space for the value
            color: "#FFFFFF",
            fontSize: 11,
            textAlign: "left", // Align values to the left
        },
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1, // Places the background below the content
            opacity: .5,
            backgroundColor: 'rgb(248, 101, 203, .1)'
        },
        lastTableRow: {
            flexDirection: "row",
            borderWidth: 1,
            borderColor: 'darkorange',
            borderRightWidth: 0
        },
        tableRow: {
            flexDirection: "row",
            borderWidth: 1,
            borderColor: 'darkorange',
            borderBottomWidth: 0,
            borderRightWidth: 0
        },
        tableCellHeader: {
            flex: 15,
            textAlign: "left",
            fontWeight: "bold",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#000",
        },
        tableCellHeaderSm: {
            flex: 2.25,
            textAlign: "left",
            fontWeight: "bold",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#000",
        }, tblCell: {
            flex: 1,
            textAlign: "center",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#fff",
        },
        tblCellRest: {
            flex: 12,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: "#fff",
        },
        tableCell: {
            flex: 4.8,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: '#fff'

        },
        tableCellCenter: {
            flex: 4.8,
            textAlign: "center",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "darkorange",
            color: '#000',


        },
        tableCellSm: {
            flex: 3.68,
            textAlign: "left",
            padding: 5,
            borderStyle: "solid",
            borderRightWidth: 1,
            borderRightColor: "#000",

        },
        checkbox: {
            flex: 1, // Allocate small space for the checkbox
            display: "flex",
            justifyContent: "center",
        },
        box: {
            height: 10,
            width: 10,
            borderWidth: 1,
            borderColor: "#FFFFFF",
            marginLeft: 5,
        },
        checked: {
            backgroundColor: "#FFFFFF", // Fill checked box
        },
        tiltedImageContainer: {
            width: '25%',
            height: 200,
            margin: 10,
            border: '1px solid'
        },
        circleImg: {
            width: 110,
            height: 110,
            borderRadius: '50%',
            border: '1px solid darkorange',
            // transform: 'rotate(-30deg)',
            // backgroundColor:'blue',
            zIndex: 2, // Places the background below the content
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        },
        tiltedImg: {
            width: 200,
            height: 200,
            padding: 20,
            overflow: 'hidden',
            // transform: 'rotate(-30deg)',
            border: '8px solid darkorange',
            borderStyle: 'solid',
            // backgroundColor:'blue',
            zIndex: 2, // Places the background below the content
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',

        },
        tiltedText: {
            transform: 'rotate(-30deg)',
        },
        f1: {
            flex: 1
        },
        f4: {
            flex: 4,
        },
        width100pct: {
            width: '100%',
        },
        borderView: {
            width: '100%',
            height: '170px',
            padding: 15,
            alignItems: 'flex-start',
            overflow: 'hidden',
            border: '8px solid #0091cd',
            borderStyle: 'solid',
            backgroundColor: '#fff',
            zIndex: 2, // Places the background below the content
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',

        },
        rect: {
            width: '33%',
            height: 40,
            display: 'flex'
        },
        circle: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            border: '3px solid orange',
            justifyContent: 'center',
            alignItems: 'center',
            // marginTop: 10,
        },
        circleText: {
            fontWeight: 'bold',
            fontSize: 16,
            color: 'orange',
            borderRadius: '8px',
            height: 16,
            width: 16
        },
        part_80: {
            flex: 80,
            // border: '2px solid rgba(111,111,111,0.2)',
            padding: 10,
            textAlign: 'left',
        },
        part_20: {
            flex: 20,
            // border: '2px solid rgba(111,111,111,0.2)',
            textAlign: 'center',
        },
        sectionContainer: {
            flexDirection: 'row',
            // marginBottom: 20,
            // backgroundColor: '#fde9d9',

        },
        leftSection: {
            flex: 1,
            // border: '2px solid rgba(111,111,111,0.2)',
            padding: 10,
            marginRight: 10,
            textAlign: 'center',
        },
        middleSection: {
            flex: 1,
            padding: 10,
            textAlign: 'center',
        },
        rightSection: {
            flex: 1,
            padding: 10,
            textAlign: 'center',
        },
        balloon: {
            width: 120,
            height: 120,
            position: 'relative',
            backgroundColor: '#FFD700',
            borderRadius: '50%',
            padding: 10,
            margin: 'auto',
        },
        textInBalloon1: {
            position: 'absolute',
            top: '20%',
            left: '20%',
            fontSize: 11,
            textAlign: 'center',
            color: '#000',
        },

        textInBalloon2: {
            position: 'absolute',
            top: '40%',
            left: '24%',
            fontSize: 12,
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#fff',
        },
        image: {
            width: 100,
            height: 100,
            // borderRadius: 10,
            border: '2px solid black',
            objectFit: 'cover',
        },
        box_assessment: {
            width: 70,
            height: 100,
            borderRadius: 10,
            border: 'none',
        },
        purple: {
            backgroundColor: '#7259b8'
        },
        blue: {
            backgroundColor: '#1961ae'
        },
        lightgreen: {
            backgroundColor: '#4dbe07'
        },
        pink: {
            backgroundColor: '#df0384'
        },
        firozi: {
            backgroundColor: '#0091cd'
        },
        box_200: {
            width: 200,
            height: 200,
        },
        emojiRubric: {
            width: 30,
            height: 30,
            objectFit: 'cover'
        },
        emoji: {
            width: 40,
            height: 40,
            objectFit: 'cover'
        },
        tick_img: {
            width: 30,
            height: 30,
            objectFit: 'contain'
        },
        sel_resource_img: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            borderRadius: 4,
            border: '2px solid orange',
            padding: 5
        },
        resource_img: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            borderRadius: 4,
            border: '1px solid grey',
            opacity: .4,
            padding: 5
        },
        green_tick: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            borderRadius: 4,
            border: '2px solid orange',
            padding: 10
        },
        grey_tick: {
            width: 50,
            height: 50,
            objectFit: 'contain',
            borderRadius: 4,
            border: '1px solid grey',
            opacity: .4,
            padding: 10
        }
    });
    useEffect(() => {
        // console.log(studentInfo.partA2)
        let ctr1 = 0;
        let tmpArr1 = []
        // console.log(studentInfo.partA4.parentTeacherPartnership)
        var tmpStudent = studentInfo;
        tmpStudent.partA4.parentTeacherPartnership.lstNeedsSupport.forEach((item1, item1Idx) => {
            if ((item1Idx && item1Idx % 3 == 0) || item1Idx == tmpStudent.partA4.parentTeacherPartnership.lstNeedsSupport.length - 1) {
                tmpStudent.partA4.parentTeacherPartnership.lstSupportRender.push(tmpArr1)
                ctr1++;
                tmpArr1 = []
                // console.log(item1Idx, '=3 pushed', item1Idx == tmpStudent.partA4.parentTeacherPartnership.lstNeedsSupport.length - 1, 'ctr=', ctr1)
            } else {
                // console.log(item1Idx, '<3,ctr=', ctr1)
            }
            tmpArr1.push(item1)
        })
        // console.log(tmpStudent.partA4.parentTeacherPartnership.lstSupportRender)
        setStudentInfo({ ...tmpStudent })

        // console.log('student = ', props, props.studentId, props.studentName, props.classSectionId, props.imgPath, props.lstStudentPdf[0], props.partAColor, props.partBColor)
    }, [])
    const getFormattedDt = (dateStr) => {
        const date = new Date(dateStr);

        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        return `${day}-${month}, ${year}`;
    }
    var studentImageUrl = `https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${props.imgPath}`;
    const [studentInfo, setStudentInfo] = useState({
        "schoolInfo": {
            "school": "Sunrise Public School",
            "address": "123 Elm Street",
            "pin": "560001",
            "udise": "123456789",
            "apaarid": "APAARI005",
            "teacherCode": "TCH001"
        },
        "partA1": {
            "studentId": "S001",
            "generalInfo": {
                "student": props.studentName,
                "rollNo": "205",
                "enrollmentNo": "ENR123",
                "cls": props.cls,
                "section": props.clsSection,
                "dob": "2005-05-15",
                "age": 10,
                "address": "456 Maple Avenue, New Delhi",
                "phone": "9876543210",
                "photo": `https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=${props.imgPath}`,
                "motherInfo": {
                    "parentId": "P001",
                    "parent": "Suman Kumari",
                    "education": "Graduate",
                    "occupation": "Teacher"
                },
                "fatherInfo": {
                    "parentId": "P002",
                    "parent": "Rajesh Kumar",
                    "education": "Postgraduate",
                    "occupation": "Engineer"
                },
                "guardianInfo": {
                    "parentId": "P003",
                    "parent": "Uncle Ramesh",
                    "education": "High School",
                    "occupation": "Farmer"
                },
                "noOfSiblings": 2,
                "siblingsAge": [8, 12],
                "motherTongue": "Hindi",
                "instructionMedium": "English",
                "flgRuralUrban": "Urban"
            },
            "attendanceInfo": {
                "lstAttendance": [
                    { "monthId": 1, "month": "Apr", "workingDays": 22, "daysAttended": 20, "pctAttendance": "90%" },
                    { "monthId": 2, "month": "May", "workingDays": 20, "daysAttended": 18, "pctAttendance": "90%" },
                    { "monthId": 3, "month": "Jun", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 4, "month": "Jul", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 5, "month": "Aug", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 6, "month": "Sep", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 7, "month": "Oct", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 8, "month": "Nov", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 9, "month": "Dec", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 10, "month": "Jan", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 11, "month": "Feb", "workingDays": "", "daysAttended": "", "pctAttendance": "" },
                    { "monthId": 12, "month": "Mar", "workingDays": "", "daysAttended": "", "pctAttendance": "" }
                ],
                "lowAttendanceReason": "Medical reasons"
            },
            "lstInterest": [
                { "interestId": 1, "interest": "Reading", "interested": true },
                { "interestId": 2, "interest": "Dancing or Singing", "interested": false },
                { "interestId": 3, "interest": "Playing a musical instrument", "interested": false },
                { "interestId": 4, "interest": "Sports or Games", "interested": false },
                { "interestId": 5, "interest": "Creative writing", "interested": false },
                { "interestId": 6, "interest": "Gardening", "interested": false },
                { "interestId": 7, "interest": "Yoga", "interested": false },
                { "interestId": 8, "interest": "Art", "interested": false },
                { "interestId": 9, "interest": "Craft", "interested": false },
                { "interestId": 10, "interest": "Cooking", "interested": false },
                { "interestId": 11, "interest": "Regular chores at home with significant others (father, mother, guardian, sibling, etc.)", "interested": false }
            ]
        },
        "partA2": {
            "aboutMe": {
                "relative": "family",
                "address": "C-90, Gali No. 6, Karim Nagar, Delhi",
                "freeTime": "completing my homework and learning new words to enhance my German vocabulary",
                "habit": "spending time making tea and cooking snacks",
                "responsible": "sometimes",
                "doBetterIn": "playing, singing, communicating",
                "showCareBy": "paying gratitude towards them",
                "feelProudWhen": "I achieve a top 5 position in the class"
            },
            "myGoalSetting": {
                "personal": {
                    "whyGoal": "When I see foreign people, I feel like understanding them better and promoting India on the global stage",
                    "goalStep1": "I study topics of interest to foreign people like culture, history, and lifestyle",
                    "goalStep2": "I make an effort to converse with them on various topics to better understand them"
                },
                "academic": {
                    "whyGoal": "I want to improve my academic performance and raise my rank in class",
                    "goalStep1": "Study consistently, focusing on weaker subjects like Mathematics",
                    "goalStep2": "Utilize the internet for additional learning and practice"
                }
            },
            "myLearning": {
                "lstSchool": [
                    "Public Speaking",
                    "Problem-Solving",
                    "Technology & Coding",
                    "Teamwork & Collaboration"
                ],
                "lstOutside": [
                    "Sports & Physical Fitness",
                    "Volunteering/Community Service",
                    "Arts & Culture (Painting, Dance, Music)",
                    "Coding or Digital Literacy"]
            },
            "forMyTeacher": {
                "helpMeWith": "study techniques and exam preparation",
                "teacherToKnow": "about my interests in playing and drawing"
            }
        },
        "partA3": {
            "myAmbitionCard": {
                "myAmbition": "Become a successful AI Engineer specializing in cutting- edge innovations.",
                "lstSkillsNeeded": ["Machine Learning", "Deep Learning", "Critical Thinking", "Leadership"],
                "achieveAmitionByDt": "2027-06-30",
                "lstFocusSubjects": ["Mathematics", "Computer Science", "Physics"],
                "studyHabits": ["Daily Practice", "Group Study", "Time Management"],
                "iWill": {
                    "takeGuidanceFrom": "Mentor, Parents, Teachers",
                    "helpMeBy": "Providing resources, encouragement, and regular feedback",
                    "learnNew": "Advanced Programming, AI Concepts",
                    "iWillFeel": "Proud and Accomplished",
                    "myParentsWillFeel": "Happy and Proud"
                }
            }
        },
        "partA4": {
            "parentTeacherPartnership": {
                "lstResourcesAtHome": [10, 20, 30],
                "childUnderstanding": {
                    "motivated": 10,
                    "schedule": 20,
                    "difficult": 40,
                    "progress": 30
                },
                "lstSupportRender": [],
                "lstNeedsSupport": [
                    { "supportId": 1, "support": "Languages (R1, R2, R3)", "needed": true },
                    { "supportId": 2, "support": "Mathematics", "needed": true },
                    { "supportId": 3, "support": "Science", "needed": true },
                    { "supportId": 4, "support": "Social Science", "needed": true },
                    { "supportId": 5, "support": "Building self-belief and self-reliance", "needed": true },
                    { "supportId": 6, "support": "Developing social skills and conflict resolution", "needed": true },
                    { "supportId": 7, "support": "Managing difficult emotions like anger", "needed": true },
                    { "supportId": 8, "support": "Developing effective study skills like time management", "needed": true },
                    { "supportId": 9, "support": "Vocational Guide/Digital Literacy", "needed": true }
                ],
                "parentSupportRemarks": "Fostering a strong parent-teacher partnership is essential to ensure your child's holistic development. While teachers support at school, use this space to write how can you provide additional support to your child at home."
            }
        }
    });

    const RoundBox = ({ title }) => <View style={{ flexDirection: 'column', flex: 25, border: '2px solid darkorange', borderRadius: 6, height: 80, width: 'auto', backgroundColor: '#fdeada' }}>
        <Text style={styles.header2}>{title}</Text>
    </View>;
    const SectionTitle = ({ title, color, bgColor, borderColor }) => <Text style={[styles.header2, { backgroundColor: bgColor, color: color, borderColor: borderColor }]}>{title}</Text>
    const PartHeader = ({ title }) => <Text style={styles.header1}>{title}</Text>;
    const SubHeader = ({ subTitle }) => <Text style={styles.header2}>{subTitle}</Text>;
    return <Document>
        {props.lstStudentPdf.map(function (student, idx) {
            return <>
                {props.cbox1 && <Page size="A4" style={styles.page}>
                    {/* Background with tricolor curved shapes */}
                    <Svg style={styles.overlay} height="100%" width="100%" viewBox="0 0 600 800">
                        {donutPositions.map(({ cx, cy }, index) => {

                            return <React.Fragment key={index}>
                                <Circle
                                    cx={cx} // Random x position
                                    cy={cy} // Random y position
                                    r="40" // Outer circle radius
                                    stroke="#40ffc080" // Light purple fill
                                    strokeWidth="5"
                                    fill="none"
                                />
                                <Circle
                                    cx={cx} // Match outer circle x position
                                    cy={cy} // Match outer circle y position
                                    r="20" // Inner circle radius
                                    stroke="#40f9f9f9" // Matches purple background
                                    strokeWidth="5"
                                    fill="none"
                                />
                            </React.Fragment>
                        })}
                    </Svg>

                    {/* School Information */}
                    <View style={styles.section}>
                        <Text style={styles.header}>School Information</Text>
                        <View style={[styles.row, { marginTop: 10 }]}>
                            <Text style={styles.label}>School:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.school}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Address:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.address}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Pin:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.pin}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Teacher Code:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.teacherCode}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>UDISE:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.udise}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>APAAR ID:</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{studentInfo.schoolInfo.apaarid}</Text>
                        </View>
                    </View>
                    {/* Content Section */}
                    <View style={styles.section}>
                        <Text style={styles.header}>General Information</Text>
                        <View style={[styles.row, { marginTop: 10 }]}>
                            <Text style={styles.label}>Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{props.studentName}</Text>
                        </View>
                        {/* Roll No. Row */}
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Roll No.</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.rollNo}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Registration No.</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.regsNo}</Text>
                            </View>
                        </View>
                        {/* Class Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Class</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{props.cls}</Text>
                        </View>
                        {/* Class Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Section</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{props.clsSection}</Text>
                        </View>
                        {/* Address Row */}
                        <View style={styles.row}>
                            <Text style={styles.label}>Address</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{studentInfo.partA1.generalInfo.address}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Phone</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{studentInfo.partA1.generalInfo.phone}</Text>
                        </View>

                        <View style={styles.row}>
                            <Text style={styles.label}>Mother Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{studentInfo.partA1.generalInfo.motherInfo.parent}</Text>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Mother Education</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.motherInfo.education}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Occupation</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.motherInfo.occupation}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Father Name</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{studentInfo.partA1.generalInfo.fatherInfo.parent}</Text>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Father Education</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.fatherInfo.education}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Occupation</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.fatherInfo.occupation}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Number of siblings</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.noOfSiblings}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Siblings' age</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{student.partA1.generalInfo.siblingsAge}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <View style={styles.firsthalf}>
                                <Text style={styles.label1}>Mother Tongue</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.partA1.generalInfo.motherTongue}</Text>
                            </View>
                            <View style={styles.secondhalf}>
                                <Text style={styles.label1}>Instruction Medium</Text>
                                <Text style={styles.colon1}>:</Text>
                                <Text style={styles.value1}>{studentInfo.schoolInfo.instructionMedium}</Text>
                            </View>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Rural/Urban</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.value}>{student.schoolInfo.flgRuralUrban}</Text>
                        </View>


                    </View>
                    <View style={[styles.section, { border: 'none' }]}>
                        {/* Attendance Table */}
                        <Text style={styles.header}>Attendance Information</Text>
                        <View style={styles.table}>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Month</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.month}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Working Days</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.workingDays}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>Days Attended</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.daysAttended}
                                    </Text>
                                ))}
                            </View>
                            <View style={styles.tableRow}>
                                <Text style={styles.tableCellHeader}>% Attendance</Text>
                                {student.partA1.attendanceInfo.lstAttendance.map((record) => (
                                    <Text key={record.monthId} style={styles.tableCell}>
                                        {record.pctAtendance}
                                    </Text>
                                ))}
                            </View>
                        </View>
                        <View style={styles.lastTableRow}>
                            <Text style={styles.tableCellHeaderSm}>Reason</Text>
                            <Text style={styles.tblCellRest}>{student.partA1.attendanceInfo.lowAttendanceReason || ""}</Text>

                        </View>

                    </View>
                    <View style={styles.section}>
                        <Text style={styles.header}>Interest(I am interested in):</Text>

                        {student.partA1.lstInterestRender.map(function (interestArr, interestIdx) {
                            return <View style={[styles.row, { flexWrap: 'wrap', marginTop: 2, marginBottom: 2 }]}>
                                {interestArr.map(function (subItem, subIdx) {
                                    return <View style={[styles.firsthalf]}>
                                        <Text style={[styles.label, { width: 'auto' }]}>{subItem.interest}</Text>
                                        <Text style={styles.colon}>:</Text>
                                        <Image style={{ width: 20, height: 20 }} src={'https://sms.cooledsys.com/tick.png'} />
                                    </View>
                                })}
                            </View>
                        })}
                    </View>

                </Page>}
                {/* Second page with content */}
                {/*line 856*/}
                {props.cbox2 && <Page style={[styles.page, styles.bgPartA2]}>
                    <View >
                        <PartHeader title="Part A(2)" />
                        {<SubHeader subTitle="All About Me!" />}

                        {/* Section 1 */}
                        <View style={[styles.sectionContainer]}>
                            <View style={styles.part_80}>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I live with my </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.relative}</Text><Text>. </Text>
                                        <Text>We stay at </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.address}</Text><Text>. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I spend my free time doing </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.freeTime}</Text><Text>. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.habit}</Text><Text> very well. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I am responsible </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.responsible}</Text><Text>. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I could do better specially when it comes to </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.doBetter}</Text><Text>. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I care about others. I show it by </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.showCareBy}</Text><Text>. </Text>
                                    </Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                        <Text>I feel proud of myself when </Text><Text style={{ textDecoration: "underline" }}>{studentInfo.partA2.aboutMe.feelProudWhen}</Text><Text>. </Text>
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.part_20}>
                                <Image style={[styles.circleImg]} src={studentInfo.partA1.generalInfo.photo} />
                                <Text>{props.studentName}</Text>
                            </View>
                        </View>
                        <View >
                            <SectionTitle color="#000" bgColor='#fabf8f' borderColor='none' title="My Goal Setting" />
                            <View style={[styles.row]}>
                                <RoundBox title="My Academic Goal" />
                                <View style={{ flex: 75, padding: 5 }}>
                                    <View style={[styles.row, { alignItems: 'flex-start', justifyContent: 'flex-start' }]}>
                                        <Text style={{ width: '100%', lineHeight: '1.3' }}>
                                            <Text>This goal is important to me because </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.academic.whyGoal}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text>I will reach this goal by: </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text style={{ width: '100%', lineHeight: '1.5' }}>
                                            <Text>Step 1: </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.academic.goalStep1}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text style={{ width: '100%', lineHeight: '1.5' }}>
                                            <Text>Step 2: </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.academic.goalStep2}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                </View>
                            </View>
                            <View style={[styles.row]}>
                                <View style={{ flex: 75, padding: 5 }}>
                                    <View style={[styles.row, { alignItems: 'flex-start', justifyContent: 'flex-start' }]}>
                                        <Text style={{ width: '100%', lineHeight: '1.3' }}>
                                            <Text>This goal is important to me because </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.personal.whyGoal}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text>I will reach this goal by: </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text style={{ width: '100%', lineHeight: '1.5' }}>
                                            <Text>Step 1: </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.personal.goalStep1}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                    <View style={styles.row}>
                                        <Text style={{ width: '100%', lineHeight: '1.5' }}>
                                            <Text>Step 2: </Text><Text style={{ textDecoration: 'underline' }}>{studentInfo.partA2.myGoalSetting.personal.goalStep2}</Text><Text> .</Text>
                                        </Text>
                                    </View>
                                </View>
                                <RoundBox title="My Personal Goal" />
                            </View>
                        </View>

                        <View >
                            <SectionTitle color="#000" bgColor='#fabf8f' borderColor='none' title="My Learnings" />
                            <View style={[styles.row, { marginTop: 10 }]}>
                                <View style={styles.leftPart}>
                                    <Text >Three new things I learnt at school: </Text>
                                    <ul style={{ marginTop: 5 }}>{
                                        studentInfo.partA2.myLearning.lstSchool?.map(function (item, i) {
                                            return <Text key={"f_" + (i + 1)} style={{ lineHeight: 1.4, fontSize: 12 }}>{(i + 1)}. {item}</Text>
                                        })
                                    }</ul>
                                </View>
                                <View style={styles.leftPart}>
                                    <Text >Three new things I learnt outside school: </Text>
                                    <ul style={{ marginTop: 5 }}>{
                                        studentInfo.partA2.myLearning.lstOutside?.map(function (item, i) {
                                            return <Text key={"f_" + (i + 1)} style={{ lineHeight: 1.4, fontSize: 12 }}>{(i + 1)}. {item}</Text>
                                        })
                                    }</ul>
                                </View>
                            </View>

                        </View>
                        <View >
                            <SectionTitle color="#000" bgColor='#fabf8f' borderColor='none' title="For My Teacher" />
                            <View style={{ width: '100%', paddingTop: 10 }}>
                                <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                    <Text style={{ marginBottom: 6 }}>I would like my teacher to help me with </Text>
                                    <Text style={{ textDecoration: 'underline', marginBottom: 6 }}>
                                        {studentInfo.partA2.forMyTeacher.helpMeWith}
                                    </Text>
                                    <Text style={{ marginBottom: 6 }}> .</Text>
                                </Text>
                            </View>
                            <View style={{ width: '100%', paddingTop: 10 }}>
                                <Text style={{ width: '100%', lineHeight: '1.4' }}>
                                    <Text style={{ marginBottom: 6 }}>I would like my teacher to know </Text>
                                    <Text style={{ textDecoration: 'underline', marginBottom: 6 }}>
                                        {studentInfo.partA2.forMyTeacher.teacherToKnow}
                                    </Text>
                                    <Text style={{ marginBottom: 6 }}> .</Text>
                                </Text>
                            </View>


                        </View>
                    </View>
                </Page>}
                {
                    props.cbox3 && <Page>
                        <StudentAmbitionCard
                            myAmbitionCard={
                                studentInfo.partA3.myAmbitionCard}
                        />
                    </Page >
                }
                {props.cbox4 && <Page style={[styles.page, { backgroundColor: '#fff' }]}>
                    <Path
                        d="M 500 10 L 520 10 L 510 30 Z"
                        fill="darkorange"
                    />
                    <PartHeader title="Part A(4)" />
                    <SubHeader subTitle="Parent-Teacher Partnership Card" />
                    <View style={[styles.row, { marginTop: 10 }]}>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>Resources available to your child at home.</Text>
                    </View>
                    <View style={{ height: 100, marginBottom: 10 }}>
                        <View style={{ flex: 1, width: '100%', flexDirection: 'column' }}>
                            <View style={{ flex: 6, flexDirection: 'column' }}>
                                <View style={{ flex: 1, flexDirection: 'row', border: '1px solid #1961ae', padding: 2 }}>
                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourceBooks ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/buk.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Books</Text>
                                        </View>
                                    </View>
                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourceMagazine ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/magazine.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Magazines</Text>
                                        </View>

                                    </View>


                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourceToys ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/sport.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Toys/Games</Text>
                                        </View>

                                    </View>

                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourcePhone ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/smartphone.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Phone</Text>
                                        </View>
                                    </View>
                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourceComputer ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/cmp.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Computer</Text>
                                        </View>
                                    </View>

                                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <View style={{ flex: 3, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                            <Image style={[student.partA1.generalInfo.hpcResourceInternet ? styles.sel_resource_img : styles.resource_img, { textAlign: 'center' }]}
                                                src={"https://sms.cooledsys.com/internet.png"} />
                                        </View>
                                        <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Text style={{ fontSize: 10, textAlign: 'center' }}>Internet</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{ marginBottom: 10 }}>
                        <SectionTitle color="#fff" bgColor="#e36c0a" borderColor="none" title="Understanding of my Child" />
                        <View style={[styles.row, { marginBottom: 0 }]}>
                            <View style={{ flex: 1, flexDirection: 'row', height: 70 }}>{/* Row */}
                                {/* 1st Column */}<View style={[styles.leftPart, { border: '1px solid darkorange', borderTop: 'none', padding: 15 }]}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>1. My child seems motivated to learn and engage with new concepts learnt at school.</Text>
                                </View>
                                {/* 2nd Column */}<View style={[styles.leftPart, { flexDirection: 'row', border: '1px solid darkorange', borderTop: 'none', borderLeft: 'none' }]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={[styles.row, { flex: 3, marginTop: 5 }]}>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.motivated == 10 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo1.png"} />
                                                </View>

                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.motivated == 20 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo2.png"} />
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.motivated == 30 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo3.png"} />
                                                </View>


                                            </View>

                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.motivated == 40 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo4.png"} />
                                                </View>
                                            </View>
                                        </View>
                                        <View style={[styles.row, { flex: 1, backgroundColor: '#fde9d9', borderTop: '1px solid darkorange', marginBottom: 0 }]}>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Yes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Sometimes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>No</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Not Sure</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.row, { marginBottom: 0 }]}>
                            <View style={{ flex: 1, flexDirection: 'row', height: 70 }}>{/* Row */}
                                {/* 1st Column */}<View style={[styles.leftPart, { border: '1px solid darkorange', borderTop: 'none', padding: 15 }]}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>2. My child follows a schedule at home that includes curriculum and other activities, social connectivity, and screen time.</Text>
                                </View>
                                {/* 2nd Column */}<View style={[styles.leftPart, { flexDirection: 'row', border: '1px solid darkorange', borderTop: 'none', borderLeft: 'none' }]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={[styles.row, { flex: 3, marginTop: 5 }]}>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 10 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo1.png"} />
                                                </View>

                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 20 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo2.png"} />
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 30 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo3.png"} />
                                                </View>


                                            </View>

                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 40 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo4.png"} />
                                                </View>
                                            </View>
                                        </View>
                                        <View style={[styles.row, { flex: 1, backgroundColor: '#fde9d9', borderTop: '1px solid darkorange', marginBottom: 0 }]}>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Yes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Sometimes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>No</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Not Sure</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>

                        <View style={[styles.row, { marginBottom: 0 }]}>
                            <View style={{ flex: 1, flexDirection: 'row', height: 70 }}>{/* Row */}
                                {/* 1st Column */}<View style={[styles.leftPart, { border: '1px solid darkorange', borderTop: 'none', padding: 15 }]}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>3. My child finds the grade-level curriculum difficult and needs additional support.</Text>
                                </View>
                                {/* 2nd Column */}<View style={[styles.leftPart, { flexDirection: 'row', border: '1px solid darkorange', borderTop: 'none', borderLeft: 'none' }]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={[styles.row, { flex: 3, marginTop: 5 }]}>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 10 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo3.png"} />
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 20 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo2.png"} />
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 30 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo1.png"} />
                                                </View>


                                            </View>

                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.difficult == 40 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo4.png"} />
                                                </View>
                                            </View>
                                        </View>
                                        <View style={[styles.row, { flex: 1, backgroundColor: '#fde9d9', borderTop: '1px solid darkorange', marginBottom: 0 }]}>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Yes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Sometimes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>No</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Not Sure</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.row, { marginBottom: 0 }]}>
                            <View style={{ flex: 1, flexDirection: 'row', height: 70 }}>{/* Row */}
                                {/* 1st Column */}<View style={[styles.leftPart, { border: '1px solid darkorange', borderTop: 'none', padding: 15 }]}>
                                    <Text style={{ width: '100%', lineHeight: '1.4' }}>4. My child is making good progress as per his/her grade.</Text>
                                </View>
                                {/* 2nd Column */}<View style={[styles.leftPart, { flexDirection: 'row', border: '1px solid darkorange', borderTop: 'none', borderLeft: 'none' }]}>
                                    <View style={{ flex: 1, flexDirection: 'column' }}>
                                        <View style={[styles.row, { flex: 3, marginTop: 5 }]}>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.progress == 10 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo1.png"} />
                                                </View>

                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.progress == 20 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo2.png"} />
                                                </View>
                                            </View>
                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.progress == 30 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo3.png"} />
                                                </View>


                                            </View>

                                            <View style={{ flex: 1, flexDirection: 'column' }}>
                                                {/* emoji wla div */}
                                                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Image style={[studentInfo.partA4.parentTeacherPartnership.childUnderstanding.progress == 40 ? styles.sel_resource_img
                                                        : styles.resource_img, { textAlign: 'center' }]}
                                                        src={"https://sms.cooledsys.com/emo4.png"} />
                                                </View>
                                            </View>
                                        </View>
                                        <View style={[styles.row, { flex: 1, backgroundColor: '#fde9d9', borderTop: '1px solid darkorange', marginBottom: 0 }]}>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Yes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Sometimes</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>No</Text>
                                            </View>
                                            {/* text wla div */}
                                            <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                                <Text style={{ textAlign: 'center', fontSize: '10' }}>Not Sure</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 10 }}>
                        <SectionTitle title="At school, my child needs support with:" color="#fff" bgColor="#e36c0a" borderColor="none" />

                        {studentInfo.partA4.parentTeacherPartnership.lstSupportRender && studentInfo.partA4.parentTeacherPartnership.lstSupportRender.map(function (supportArr, supportIdx) {
                            return <View style={[styles.row, { flexWrap: 'wrap', marginBottom: 0, borderTop: '1px solid darkorange', borderBottom: supportIdx == studentInfo.partA4.parentTeacherPartnership.lstSupportRender.length - 1 ? '1px solid darkorange' : 'none' }]}>
                                {supportArr.map(function (subItem, subIdx) {
                                    return <View style={[styles.firsthalf, { height: 40, padding: 2, borderLeft: '1px solid darkorange', borderRight: supportIdx == studentInfo.partA4.parentTeacherPartnership.lstSupportRender.length - 1 && subIdx !== 0 ? '1px solid darkorange' : (subIdx < 2 ? 'none' : '1px solid darkorange') }]}>
                                        <Text style={[styles.label, { width: '100%' }]}>{subItem.support}</Text>
                                        <Text style={styles.colon}>:</Text>
                                        <Image style={{ width: 20, height: 20 }} src={'https://sms.cooledsys.com/tick.png'} />
                                    </View>
                                })}
                            </View>
                        })}
                    </View>
                    <View style={[styles.section, { margin: 0 }]}>
                        <SectionTitle title="Based on my discussion with the teacher, I will support my child at home by:" color="#fff" bgColor="#e36c0a" borderColor="none" />
                        <View style={[styles.sectionContainer, { padding: 5 }]}>
                            <Text style={{ width: "100%", fontSize: 11, lineHeight: '1.4' }}>{studentInfo.partA4.parentTeacherPartnership.parentSupportRemarks}</Text>
                        </View>
                    </View>
                    <View style={{ backgroundColor: 'darkorange', width: '90%', height: 1, position: 'absolute', bottom: 30, right: 30, left: 30 }}></View>
                </Page>}
                {props.cbox5 &&
                    <StudentSummary
                        bgColor={""}
                    />
                }
            </>
        })}
    </Document >
}

// Render the PDF
const HpcMiddle = (props) => {
    // console.log(props)
    return <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <StudentPDF key={'spdf_' + props.sliderKey}
            lstStudentPdf={props.lstStudentPdf}
            basePathStudent={props.basePathStudent}
            basePathActivity={props.basePathActivity}
            cbox1={props.cbox1}
            cbox2={props.cbox2}
            cbox3={props.cbox3}
            cbox4={props.cbox4}
            cbox5={props.cbox5}
            partAColor={props.partAColor}
            partBColor={props.partBColor}
            studentName={props.studentName}
            studentId={props.studentId}
            classSectionId={props.classSectionId}
            imgPath={props.imgPath}
            cls={props.cls}
            clsSection={props.clsSection}
        />
    </PDFViewer>
};

export default HpcMiddle;